import util from '@/libs/util'

//外籍雇员管理列表
export function employeePage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/employee/page',
    params
  })
}

//外籍雇员处理列表
export function employeeProcessPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/employeeProcess/page',
    params
  })
}

// 新增外籍雇员
export function employeeAdd(data) {
  return util.http({
    method: 'post',
    url: 'org/auth/employee',
    data
  })
}

// 修改外籍雇员
export function employeePut(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/employee',
    data
  })
}

//外籍雇员模板
export function employeeTemplate(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/employee/template',
    params
  })
}

//外籍雇员导出
export function employeeExport(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/employee/export',
    params
  })
}

//分页查询职工变更记录列表
export function employeeChangeLogPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/employeeChangeLog/page',
    params
  })
}

// 职工入职
export function employeeEntryt(params) {
  return util.http({
    method: 'put',
    url: 'org/auth/employee/entry',
    params
  })
}

// 职工离职
export function employeeTurnover(params) {
  return util.http({
    method: 'put',
    url: 'org/auth/employee/turnover',
    params
  })
}

//分页查询职工家属列表
export function employeeFamilyMemberPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/employeeFamilyMember/page',
    params
  })
}

// 新增外籍雇员
export function employeeFamilyMemberAdd(data) {
  return util.http({
    method: 'post',
    url: 'org/auth/employeeFamilyMember',
    data
  })
}

export function employeeFamilyMemberPut(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/employeeFamilyMember',
    data
  })
}

export function employeeFamilyMemberDelete(params) {
  return util.http({
    method: 'DELETE',
    url: 'org/auth/employeeFamilyMember',
    params
  })
}

export function employeeDetail(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/employee/' + params.employeeId
  })
}

// 导入失败时下载模板
export function downloadErr(params) {
  return util.http({
    method: 'get',
    url: 'api/auth/file/common/download',
    params,
    responseType: 'blob'
  })
}

// 修改职工处理
export function employeeProcessPut(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/employeeProcess',
    data
  })
}

// 职工家属更改状态
export function employeeFamilyMemberUpdateStatus(params) {
  return util.http({
    method: 'put',
    url: 'org/auth/employeeFamilyMember/updateStatus',
    params
  })
}

// 职工变更记录审核
export function employeeChangeLogAudit(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/employeeChangeLog/audit',
    data
  })
}

export function employeeFamilyDetail(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/employeeFamilyMember/' + params.employeeFamilyMemberId
  })
}

// 职工处理
export function employeeHandle(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/employeeProcess/handle',
    data
  })
}

// 职工处理标记状态
export function employeeMarkStatus(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/employeeProcess/markStatus',
    data
  })
}

// 职工处理提醒
export function employeeWarn(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/employeeProcess/warn',
    data
  })
}

// 职工删除
export function employeeDelete(params) {
  return util.http({
    method: 'delete',
    url: 'org/auth/employee',
    params
  })
}

export function documentationTemplatePage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/documentationTemplate/page',
    params
  })
}